<template>
  <button @click="change" :aria-label="$t('buttons.switchView')" :title="$t('buttons.switchView')" class="action" id="switch-view-button">
    <grid-icon v-if="isList" size="1.5x" class="custom-class"></grid-icon>
    <list-icon v-else size="1.5x" class="custom-class"></list-icon>
    <span>{{ $t('buttons.switchView') }}</span>
  </button>
</template>

<script>

import { mapState, mapMutations } from 'vuex';
import { users as api } from '@/api';
import { ListIcon, GridIcon } from 'vue-feather-icons';

export default {
  name: 'switch-button',
  components: {
    GridIcon,
    ListIcon
  },
  computed: {
    ...mapState(['user']),
    isList () {
      if (this.user.viewMode === 'list') {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapMutations([ 'updateUser', 'closeHovers' ]),
    change: async function () {
      this.closeHovers();

      const data = {
        id: this.user.id,
        viewMode: (this.isList === false) ? 'list' : 'mosaic'
      };

      try {
        await api.update(data, ['viewMode']);
        this.updateUser(data);
        //store.commit('setReload', true)
      } catch (e) {
        this.$showError(e);
      }
    }
  }
};
</script>
